import { StepType } from "../types/interfaces";
import { LanguageKeys } from "./languageKeys";

export const STEPS: Record<StepType, string> = {
	email: "What is your email?",
	name: "What is your name?",
	height: "How tall are you?",
	gender: "Where do you shop?",
};

export const OUTFIT_IMAGES = [
	"https://scan.syze.ai/publicAssets/outfit-1.png",
	"https://scan.syze.ai/publicAssets/outfit-2.png",
	"https://scan.syze.ai/publicAssets/outfit-3.png",
	"https://scan.syze.ai/publicAssets/outfit-4.png",
	"https://scan.syze.ai/publicAssets/outfit-5.png",
];
export const voiceOverAssetsPath = "https://scan.syze.ai/publicAssets/new-voices-over/";
export const maleScanVideo = "https://scan.syze.ai/publicAssets/male-scan-mesh.mp4";
export const femaleScanVideo = "https://scan.syze.ai/publicAssets/scan-mesh.mp4";
export const faceScanVideo = "https://scan.syze.ai/publicAssets/face-scan-zoom.mp4";
export const maleFaceScanVideo = "https://scan.syze.ai/publicAssets/male-face-scan-zoom.mp4";
export const bodyScanPerson = "https://scan.syze.ai/publicAssets/body-scan-person.png";
export const faceScanPerson = "https://scan.syze.ai/publicAssets/face-scan-person.png";
export const fittingGuide = "https://scan.syze.ai/publicAssets/form-fitting-guide.png";
export const leSableDress = "https://scan.syze.ai/publicAssets/le-sable-dress-new.png";
export const sizeSuggestions = "https://scan.syze.ai/publicAssets/sizing-suggestions.mp4";
export const maleSizeSuggestions = "https://scan.syze.ai/publicAssets/male-sizing-suggestions.mp4";
export const maleFormFittingGuide = "https://scan.syze.ai/publicAssets/male-form-fitting.mp4";
export const formFittingGuide = "https://scan.syze.ai/publicAssets/form-fitting.mp4";
export const fullText =
	"Based on your bust measurement of 85.0 cm and waist measurement of 68.7 cm, a size S is suggested for the Le Sable Dress. This size corresponds to a bust of 86 cm and a waist of 67 cm, closely matching your measurements. The Le Sable Dress is designed for a slim fit & features a slightly stretchy fabric.";
export const setupVideo = "https://scan.syze.ai/publicAssets/phone-on-table.mp4";
export const maleSetupVideo = "https://scan.syze.ai/publicAssets/male-phone-on-table.mp4";
export const pauseIcon = "https://scan.syze.ai/publicAssets/pause-icon.svg";
export const loaderGif = "https://scan.syze.ai/publicAssets/loader.gif";
export const loaderBlackGif = "https://scan.syze.ai/publicAssets/loader-black.gif";
export const qrError = "https://scan.syze.ai/publicAssets/qrError.svg";
export const videoPoster = "https://scan.syze.ai/publicAssets/video-poster.jpg";
export const measurementProgress = "https://scan.syze.ai/publicAssets/measurement-progress.mp4";
export const maleMeasurementProgress = "https://scan.syze.ai/publicAssets/male-measurement-progress.mp4";
const maleVideoPoster = "https://scan.syze.ai/publicAssets/male-video-poster.png";
const femaleVideoPoster = "https://scan.syze.ai/publicAssets/female-video-poster.png";

// Prefer smaller, widely supported codecs first. Fallbacks are ordered.
export const videoTypes = [
	"video/webm;codecs=vp9",
	"video/webm;codecs=vp8",
	"video/webm",
	"video/mp4;codecs=avc1",
	"video/mp4",
];

export const CLOTHING_CUSTOM_FIT_SCAN = "clothing_custom_fit_scan";
export const CLOTHING_SCAN_WITH_TRY_ON = "clothing_scan_with_try_on";
export const CLOTHING_SCAN_ONLY = "clothing_scan_only";
export const CLOTHING_CUSTOM_SCAN = "clothing_custom_scan";
export const CLOTHING_TRY_ON_SCAN = "clothing_try_on_scan";
export const CLOTHING_SCAN = "clothing_scan";
export const CLOTHING_BANNER_SCAN = "clothing_banner_scan";
export const CLOTHING_TRYON_CONSUMER_SCAN = "clothing_tryon_consumer_scan";

export const TENSORFLOW_SOLUTION_PATH = "https://cdn.jsdelivr.net/npm/@mediapipe/pose";

export const posthogPublicKey = "phc_X75NZd0cP9h2AzkEgOBd8oYvRi5D0Q42TK4T8lvvyLZ";
export const posthogPublicHost = "https://eu.i.posthog.com";

export const videoConstraintsExact = {
	width: { exact: 1280 },
	height: { exact: 720 },
	facingMode: "user",
	frameRate: { ideal: 10, max: 10 },
};

export const videoConstraintsFallback = {
	width: { ideal: 1280, max: 1280 },
	height: { ideal: 720, max: 720 },
	facingMode: "user",
	frameRate: { ideal: 10, max: 10 },
};

export const videoConstraints = videoConstraintsFallback;



export const GENDER = {
	male: {
		PRE_LINK: "https://swan-video-assets.getswan.co/SWAN_AI_Video_02_PRESCAN_MALE_V02/SWAN_AI_Video_02_PRESCAN_MALE_V02-output.m3u8",
		POST_LINK: "https://swan-video-assets.getswan.co/SWAN_AI_Video_03_POSTS0CAN_MALE_V02/SWAN_AI_Video_03_POSTS0CAN_MALE_V02-output.m3u8",
	},
	female: {
		PRE_LINK: "https://swan-video-assets.getswan.co/SWAN_AI_Video_02_PRESCAN_V02/SWAN_AI_Video_02_PRESCAN_V02-output.m3u8",
		POST_LINK: "https://swan-video-assets.getswan.co/SWAN_AI_Video_03_POSTS0CAN_V02/SWAN_AI_Video_03_POSTS0CAN_V02-output.m3u8",
	},
};

export const VIDEO_POSTER_GENDER_BASED = {
	male: maleVideoPoster,
	female: femaleVideoPoster,
};

export const FACE_SCAN_HEADSHOT = {
	male: {
		forward: "https://scan.syze.ai/publicAssets/male-face-forward.mp4",
		left: "https://scan.syze.ai/publicAssets/male-face-left.mp4",
		right: "https://scan.syze.ai/publicAssets/male-face-right.mp4",
		smile: "https://scan.syze.ai/publicAssets/male-face-smile.mp4",
	},
	female: {
		forward: "https://scan.syze.ai/publicAssets/face-forward.mp4",
		left: "https://scan.syze.ai/publicAssets/face-left.mp4",
		right: "https://scan.syze.ai/publicAssets/face-right.mp4",
		smile: "https://scan.syze.ai/publicAssets/face-smile.mp4",
	},
};

export const glassesOffVideo = "https://scan.syze.ai/publicAssets/glasses-off.mp4";
export const maleGlassesOffVideo = "https://scan.syze.ai/publicAssets/male-glasses-off.mp4";

export const heroMaleModel = "https://scan.syze.ai/publicAssets/hero-male.glb";
export const heroFemaleModel = "https://scan.syze.ai/publicAssets/hero-female.glb";

export const directionMessages = [LanguageKeys.faceFront, LanguageKeys.faceLeft, LanguageKeys.faceRight, LanguageKeys.faceSmile];
